import React, { useState, useEffect } from 'react';
import './Comunidad.css';
import { Link } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';

/* ── Logo ── */
const LogoComunicar = ({ height = 40 }) => (
  <img
    src="/images/logo_centro.png"
    alt="Comunicar"
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ── Icons ── */
const IconArrow   = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconMail    = () => <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconShield  = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconCheck   = () => <svg viewBox="0 0 20 20" fill="none" width="15" height="15"><circle cx="10" cy="10" r="9" fill="rgba(139,202,175,.2)"/><path d="M6 10l3 3 5-5" stroke="#14736C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconSpinner = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;

/* Iconos decorativos para la regla de puntos */
const IconMoneda = () => (
  <svg viewBox="0 0 80 80" fill="none" width="80" height="80">
    <circle cx="40" cy="40" r="36" fill="#c8e8de" stroke="#8BCAAF" strokeWidth="2"/>
    <circle cx="40" cy="40" r="26" fill="#8BCAAF" stroke="#14736C" strokeWidth="1.5"/>
    <text x="40" y="46" textAnchor="middle" fontSize="18" fontWeight="700" fill="#14736C" fontFamily="DM Sans, sans-serif">C</text>
  </svg>
);
const IconMonedas = () => (
  <svg viewBox="0 0 80 80" fill="none" width="80" height="80">
    <circle cx="40" cy="58" r="14" fill="#c8e8de" stroke="#8BCAAF" strokeWidth="1.5"/>
    <circle cx="40" cy="48" r="14" fill="#c8e8de" stroke="#8BCAAF" strokeWidth="1.5"/>
    <circle cx="40" cy="38" r="14" fill="#8BCAAF" stroke="#14736C" strokeWidth="1.5"/>
    <text x="40" y="43" textAnchor="middle" fontSize="12" fontWeight="700" fill="#14736C" fontFamily="DM Sans, sans-serif">C</text>
  </svg>
);
const IconTarjeta = () => (
  <svg viewBox="0 0 80 80" fill="none" width="80" height="80">
    <rect x="8" y="22" width="64" height="40" rx="8" fill="#c8e8de" stroke="#8BCAAF" strokeWidth="1.5"/>
    <rect x="8" y="32" width="64" height="10" fill="#8BCAAF"/>
    <rect x="16" y="48" width="20" height="6" rx="2" fill="#14736C" opacity=".5"/>
    <rect x="44" y="48" width="16" height="6" rx="2" fill="#14736C" opacity=".5"/>
  </svg>
);

const NIVELES = [
  { id:'iniciando',    nombre:'Iniciando',    emoji:'🌱', puntosPorSol:2, puntosSubir:'Hasta acumular 1,000 puntos',    featured:false },
  { id:'consolidando', nombre:'Consolidando', emoji:'⭐', puntosPorSol:3, puntosSubir:'Desde 1,001 hasta 3,000 puntos', featured:true  },
  { id:'liderando',    nombre:'Liderando',    emoji:'👑', puntosPorSol:4, puntosSubir:'Desde 3,001 puntos en adelante', featured:false },
];

const FEATURES_BOLETIN = [
  'Ideas y estrategias para intervención en lenguaje',
  'Recursos y herramientas para aplicar en sesión',
  'Contenido relevante sobre lenguaje y práctica clínica',
  'Beneficios exclusivos en cursos y materiales',
];

export default function Comunidad() {
  const { estaLogueado, usuario } = useAuthUser();
  const [emailBoletin,    setEmailBoletin]    = useState('');
  const [nombreBoletin,   setNombreBoletin]   = useState('');
  const [enviandoBoletin, setEnviandoBoletin] = useState(false);
  const [boletinOk,       setBoletinOk]       = useState(false);
  const [boletinError,    setBoletinError]    = useState('');

  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      }),
      { threshold: 0.07 }
    );
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [boletinOk]);

  const handleBoletin = async e => {
    e.preventDefault();
    setBoletinError('');
    if (!nombreBoletin.trim()) { setBoletinError('Ingresa tu nombre'); return; }
    if (!emailBoletin.includes('@')) { setBoletinError('Email no válido'); return; }
    setEnviandoBoletin(true);
    try {
      const res = await fetch(
        'https://centrocomunicar.com/api-comunicar/endpoints/leads.php?action=boletin',
        { method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ nombre:nombreBoletin, email:emailBoletin.toLowerCase() }) }
      );
      const json = await res.json();
      if (!json.success) throw new Error(json.message || 'Error al suscribirse');
      setBoletinOk(true);
    } catch(err) {
      setBoletinError(err.message || 'Error. Intenta de nuevo.');
    } finally {
      setEnviandoBoletin(false);
    }
  };

  return (
    <div className="com-page">

      {/* NAV */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones">Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/comunidad" style={{color:'var(--verde-dk)',fontWeight:700}}>Comunidad</Link>
          <Link to="/articulos">Artículos</Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      {/* ══ PROGRAMA DE PUNTOS ══ */}
      <section className="com-puntos" id="puntos">
        <div className="com-puntos__inner">

          {/* Encabezado */}
          <div className="reveal">
            <p className="section-label">Beneficios exclusivos</p>
            <h2 className="com-puntos__subtitulo">Programa de <em>puntos</em></h2>
            <p className="com-puntos__subtitulo-sub">
              Gana puntos con cada compra y úsalos como descuento en tus próximos cursos y materiales.
            </p>
          </div>

          {/* Regla compra → acumula → canjea CON ICONOS */}
          <div className="com-puntos__regla reveal">
            <div className="com-puntos__regla-item com-puntos__regla-item--icono">
              <div className="com-puntos__regla-circulo"><IconMoneda/></div>
              <strong>Compra</strong>
              <span>Empieza a acumular puntos desde tu primera compra.</span>
            </div>
            <div className="com-puntos__regla-sep">→</div>
            <div className="com-puntos__regla-item com-puntos__regla-item--icono">
              <div className="com-puntos__regla-circulo"><IconMonedas/></div>
              <strong>Acumula</strong>
              <span>Por cada 100 puntos acumulados canjeas s/1.00 de descuento en tu próxima compra.</span>
            </div>
            <div className="com-puntos__regla-sep">→</div>
            <div className="com-puntos__regla-item com-puntos__regla-item--icono com-puntos__regla-item--dest">
              <div className="com-puntos__regla-circulo"><IconTarjeta/></div>
              <strong>Canjea</strong>
              <span>Canjea tus puntos por cursos o materiales.</span>
            </div>
          </div>

          {/* Tabla de niveles — SIN EMOJIS en la columna, diseño imagen 1 */}
          <div className="reveal">
            <h3 className="com-puntos__subtitulo">Tus puntos <em>crecen</em></h3>
            <p className="com-puntos__subtitulo-sub">Mientras más acumulas, más ganas.</p>
            <div className="com-niveles-tabla-wrap">
              {/* Cabecera */}
              <div className="com-niveles-tabla-head">
                <span>Nivel</span>
                <span>Ganas por cada s/1.00</span>
                <span>Vigencia del nivel</span>
              </div>
              {/* Filas sin emoji, solo texto */}
              {NIVELES.map(n => (
                <div key={n.id} className={`com-niveles-tabla-row${n.featured?' com-niveles-tabla-row--dest':''}`}>
                  <span>{n.nombre}</span>
                  <span>{n.puntosPorSol} puntos</span>
                  <span>{n.puntosSubir}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Términos y condiciones — SIN DUPLICADO */}
          <div className="com-puntos__terminos reveal">
            <h3 className="com-puntos__terminos-titulo">Términos y <em>condiciones</em></h3>
            <div className="com-puntos__nota">
              <div className="com-puntos__nota-inner">
                <IconShield/>
                <div>
                  <strong>Cómo canjeo mis puntos</strong>
                  <p>
                    • Aplica tus puntos como descuento directo al momento de comprar un curso o material.<br/>
                    • Se aplican de forma automática en el proceso de compra.<br/>
                    • Tus puntos se mantienen activos mientras sigas usando tu cuenta.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA registro */}
          {!estaLogueado && (
            <div className="com-puntos__cta reveal">
              <div className="com-puntos__cta-inner">
                <div>
                  <strong>¿Aún no tienes cuenta?</strong>
                  <p>Crea tu cuenta gratis y empieza a ganar puntos desde tu primera compra.</p>
                </div>
                <Link to="/registro" className="com-puntos__cta-btn">
                  Crear cuenta gratis <IconArrow/>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ══ BOLETÍN ══ */}
      <section className="com-boletin" id="boletin">
        <div className="com-boletin__inner">
          <div className="com-boletin__content reveal">
            <p className="section-label" style={{color:'var(--amarillo)'}}>Suscripción gratuita</p>
            <h2 className="com-section-titulo com-section-titulo--blanco">
              <em className="com-em--verde">Recibe nuestras novedades</em>
            </h2>
            <p className="com-section-sub com-section-sub--dark">
              Sé el primero en acceder a nuevas ideas, recursos y contenido sobre lenguaje, con beneficios exclusivos.
            </p>
            <div className="com-boletin__features">
              {FEATURES_BOLETIN.map(f => (
                <div key={f} className="com-boletin__feature">
                  <IconCheck/><span>{f}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="com-boletin__form-wrap reveal" style={{'--delay':'.15s'}}>
            {boletinOk ? (
              <div className="com-boletin__ok">
                <div className="com-boletin__ok-icon">
                  <svg viewBox="0 0 24 24" fill="none" width="36" height="36">
                    <circle cx="12" cy="12" r="10" fill="rgba(139,202,175,.2)"/>
                    <path d="M8 12l3 3 5-5" stroke="#8BCAAF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Ya estás suscrito</h3>
                <p>Revisa tu correo para confirmar. Recibirás el próximo boletín el primer lunes del mes.</p>
              </div>
            ) : (
              <form className="com-boletin__form" onSubmit={handleBoletin}>
                <div className="com-boletin__form-head">
                  <IconMail/>
                  <div>
                    <strong>Accede gratis</strong>
                    <span>Más de 300 profesionales ya forman parte</span>
                  </div>
                </div>
                {boletinError && <div className="com-boletin__error">{boletinError}</div>}
                <div className="com-boletin__field">
                  <label>Tu nombre</label>
                  <input type="text" placeholder="Ej: Ana García" value={nombreBoletin}
                    onChange={e => setNombreBoletin(e.target.value)} required/>
                </div>
                <div className="com-boletin__field">
                  <label>Correo electrónico</label>
                  <input type="email" placeholder="tu@correo.com" value={emailBoletin}
                    onChange={e => setEmailBoletin(e.target.value)} required/>
                </div>
                <button type="submit" className="com-boletin__submit" disabled={enviandoBoletin}>
                  {enviandoBoletin
                    ? <><IconSpinner/> Suscribiendo…</>
                    : <><IconMail/> Suscribirme gratis</>
                  }
                </button>
                <p className="com-boletin__legal">
                  <IconCheck/> Sin spam. Cancela cuando quieras.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* ══ FOOTER ══ */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">
              Cursos especializados y materiales terapéuticos para profesionales
              y familias que trabajan el desarrollo del lenguaje.
            </p>
            <div className="footer__social">
              <a href="https://www.instagram.com/comunicar_terapias" className="footer__social-btn" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>
              </a>
              <a href="https://www.facebook.com/comunicar.terapias" className="footer__social-btn" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868" className="footer__social-btn" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones#gratuitos">Cursos gratuitos</Link>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <a href="https://centrocomunicar.com/virtual/login/index.php" target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Materiales gratuitos</Link>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad#boletin">Boletín mensual</Link>
              <Link to="/comunidad#puntos">Programa de puntos</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Recursos gratuitos y nuevos cursos en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button type="button" className="footer__submit"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <p style={{fontSize:'.75rem',color:'rgba(255,255,255,.3)',marginTop:'.3rem'}}>
            Dirección: Teniente Carlos Moore 1386, Cercado de Lima
          </p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>

    </div>
  );
}